class Company {
    constructor(result) {
        this.id = +(result.id);
        this.id_parent = +(result.id_parent);
        this.id_root = +(result.id_root);
        this.name = result.name;
		this.label = result.name + ' (' + result.id + ')';
        this.info = result.info;
        this.id_main_user = +(result.id_main_user);
        this.main_user_email = result.main_user_email;
        this.install_key = (result.install_key);
        this.machine_rpm = +(result.machine_rpm);
        this.hide_patterns = (result.hide_patterns && result.hide_patterns === 'Y');
        this.date_licenced = +(result.date_licenced);
        this.date_deleted = +(result.date_deleted);
        this.timezone = result.timezone;
        this.api_enabled = (result.api_enabled == 1 || result.api_enabled === true);
        this.ai_connector_enabled = (result.ai_connector_enabled == 1 || result.ai_connector_enabled === true);
    }
}

class Companies {

    initialized = false;

    constructor(result) {

        this.currentCompany = null;
        this.companies = [];

        if (result) {
            for (let ix in result) {
                let c = result[ix];
                let c2 = new Company(c);

                this.companies.push(c2);
            }

            this.initialized = true;
        }

    }

    getCurrentCompany() {

        return this.currentCompany;

    }

    /**
     * @param userData UserData userData
     */
    initActiveCompany(userData) {

        if (this.getCurrentCompany() !== null && this.getCurrentCompany().id !== 0) {
            // was aready set - out here
            // Note: we allow override if current is 0 (dummy) and we now have real user data
            return this;
        }

        // check if active Company is in Settings
        if (userData.initialized && userData.settings && userData.settings.selectedCompany !== undefined) {
            this.setCurrentCompany(userData.settings.selectedCompany);
        }

        // Get Active Company from User
        if (this.getCurrentCompany() === null && userData.initialized && userData.idCompany !== null) {
            this.setCurrentCompany(userData.idCompany);
        }

        // Fallback: If still null, take first company
        if (this.getCurrentCompany() === null && this.companies.length > 0) {
            this.setCurrentCompany(this.companies[0].id);
        }

        return this;

    }

    setCurrentCompany(idCompany) {

        this.currentCompany = null;

        for (let ix in this.companies) {
            let c = this.companies[ix];

            if (c.id === +(idCompany)) {
                this.currentCompany = c;
                //console.debug("Current Company Set to",c);
                break;
            }
        }

        // Special case: if idCompany is 0 and not found in list (e.g. "All Companies" or "Global" mode)
        // we might need to handle it. However, if GetMachines expects id_company: 0,
        // and we don't have a company with id 0, we should still allow it to be passed.
        if (this.currentCompany === null && +(idCompany) === 0) {
            this.currentCompany = { id: 0, name: 'Global', timezone: 'UTC' };
        }

    }

    updateActiveCompanyTimezone(timezone) {

        if (this.currentCompany) {
            this.currentCompany.timezone = timezone;
        }

    }

    setHidePatternSetting(idCompany, value) {

        this.saveSetting(idCompany, 'hide_patterns', value);

    }

    saveSetting(idCompany, property, value) {

        const companies = [...this.companies];

        const found = companies.find(
            (obj) => {
                return (obj.id === idCompany);
            }
        );

        if (found === undefined) return null;

        if (found.hasOwnProperty(property)) found[property] = value;

        this.companies = companies;

    }

    /**
     *
     * @param sort - null or "name"
     * @param dir - can be "asc" or "desc"
     * @returns [Company]
     */
    getAllCompanies(sort, dir) {

        if (sort) {
            // Sort via comparator
            if (sort === 'name' && dir === 'desc') {
                return this.companies.sort((a, b) => a.name < b.name)
            } else if (sort === 'name') {
                return this.companies.sort((a, b) => a.name > b.name)
            }
        }

        // Fallback unsorted
        return this.companies;

    }

    clone() {
        const cloned = new Companies();
        cloned.companies = [...this.companies];
        cloned.currentCompany = this.currentCompany;
        cloned.initialized = this.initialized;
        return cloned;
    }

}

export default Companies;
